﻿import type {AccessToken} from "./types";
import type {DocumentType} from "./useDocumentApi";
import type {DocumentHeader, ExampleDocumentHeader} from "./useReceiptApi";
import {convertToDocumentHeader, useReceiptApi} from "./useReceiptApi";
import {useDocumentApi} from "./useDocumentApi";
import {computed, Ref} from "vue";

export interface DataSource {
    id: string;
    icon?: string;
    name: string;
    query(): Promise<(DocumentHeader | ExampleDocumentHeader)[]>;
}

export const useDocumentDataSources = (
    documentType: Ref<DocumentType>,
    tenantOid: Ref<number>,
    accessToken: AccessToken
) => {

    const {getExampleDocumentHeaders} = useReceiptApi(documentType, tenantOid, accessToken);

    const {readList} = useDocumentApi(undefined, documentType, accessToken);

    const exampleDataSource = computed<DataSource>(() => ({
        id: "EXAMPLES",
        name: "Examples",
        query: () => getExampleDocumentHeaders()
    }));

    const recentDataSource = computed<DataSource>(() => ({
        id: "RECENT-RECEIPTS",
        name: "Recent Receipts",
        query: () => readList({tenantOid: tenantOid.value}, {skip: 0, take: 10})
            .then(list => list.map(convertToDocumentHeader))
    }));

    // const numberSearchDataSource = computed<DataSource>(() => ({
    //     id: "NUMBER-SEARCH",
    //     name: "Number Search",
    //     query: () => readList({tenantOid: tenantOid.value, number: "5127000000"}, {skip: 0, take: 10})
    //         .then(list => list.map(convertToDocumentHeader))
    // }));

    const dataSources = computed(() => [
        exampleDataSource.value,
        recentDataSource.value,
        //numberSearchDataSource.value
    ]);

    const query = (dataSourceId: string) => {
        const ds = dataSources.value.filter(ds => ds.id === dataSourceId)[0];
        return ds
            ? ds.query()
            : Promise.reject("No dataSource");
    }

    return {
        dataSources,
        query
    }
}